var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgLoader = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62429 12.7854C7.29941 12.6688 6.9415 12.8376 6.82489 13.1625C6.70827 13.4874 6.87711 13.8453 7.20199 13.9619L7.62429 12.7854ZM3.75955 9.66778C3.8026 10.0103 4.11514 10.253 4.45762 10.2099C4.8001 10.1669 5.04284 9.85435 4.99979 9.51187L3.75955 9.66778ZM7.07153 5.4824C9.01991 4.42781 11.4543 5.15237 12.5089 7.10075L13.6082 6.50573C12.225 3.95023 9.03202 2.99989 6.47652 4.3831L7.07153 5.4824ZM12.5089 7.10075C13.5635 9.04913 12.8389 11.4835 10.8906 12.5381L11.4856 13.6374C14.0411 12.2542 14.9914 9.06124 13.6082 6.50573L12.5089 7.10075ZM10.8906 12.5381C9.84577 13.1036 8.66218 13.1579 7.62429 12.7854L7.20199 13.9619C8.56038 14.4495 10.1151 14.3792 11.4856 13.6374L10.8906 12.5381ZM4.99979 9.51187C4.79934 7.9173 5.57504 6.2924 7.07153 5.4824L6.47652 4.3831C4.51171 5.44658 3.49696 7.57895 3.75955 9.66778L4.99979 9.51187Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgLoader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loader.5e2b74012afb2ee2878a00bbb2fbaf0b.svg";